import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import FontKeys from '../FontKeys';

export default class DemoLetterPart extends Phaser.GameObjects.Container
{
    /**
     * 
     * @param {Phaser.Scene} scene 
     */
    constructor(scene, partName, partSize, id)
    {
        super(scene);

        this.highLightShape = this.scene.add.graphics();
        this.add(this.highLightShape);

        this.id = id;

        this.partTxt = ABCyaPhaser.Text.addText(0, 0, partSize, 0x3258a7, FontKeys._asapbold, partName, this, false).setOrigin(0);
        this.partWidth = this.partTxt.width;
        this.partHeight = this.partTxt.height;
        this.partState = "clear";

        ABCyaPhaser.Container.setContainerInteractive(this, false);
        this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.selectPart, this);
    }

    selectPart()
    {
        if (this.partState != "showing")
        {
            this.setShowState("showing");
            this.emit("PART_SELECT", this, this.id);
        }
    }

    setShowState(state)
    {
        if (!state) state = "clear";
        this.highLightShape.clear().lineStyle(3, 0xf4805c);
        if (state == "active")
        {
            this.highLightShape.moveTo(0, this.partHeight - 5);
            this.highLightShape.lineTo(this.partWidth, this.partHeight - 5);
        }
        else if (state == "showing")
        {
            this.highLightShape.strokeRoundedRect(-5, -5, this.partWidth + 10, this.partHeight + 10, 10);
        }

        this.partState = state;
    }
}